import { useSyncExternalStore } from 'react';
import { subscribeCueDiagnostics, getCueDiagnosticsSnapshot, type CueDiagnosticsSnapshot } from './diagnostics';

/** Subscribes a component to the shared Cue diagnostics store - see
 * diagnostics.ts's own header comment. Synchronous like any other
 * useSyncExternalStore hook (no notifyManager-style deferred scheduling
 * to worry about here - see lib/queryClient.ts's useQueryState for why
 * that mattered for a *different* piece of state). */
export function useCueDiagnostics(): CueDiagnosticsSnapshot {
  return useSyncExternalStore(subscribeCueDiagnostics, getCueDiagnosticsSnapshot);
}
